import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil, omit} from 'lodash'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import SubMenuItem from 'components/subMenuItem'
import Icon, {iconNames} from 'components/icon'
import Divider from '@material-ui/core/Divider'
import Button from '../../components/button'
import {prefix} from 'helpers/component'
import './menuButton.scss'

const getClass = prefix('menuButton-')

class MenuButton extends Component {
  state = {
    open: false,
    anchor: null,
  }

  showMenu = (e) => {
    const {onShowMenu} = this.props
    this.setState({
      open: true,
      anchor: e.currentTarget,
    })
    if (onShowMenu) onShowMenu()
  }

  hideMenu = () => {
    this.setState({open: false})
  }

  selectMenuItem = (e, item) => {
    if (!item.menuItems) {
      this.hideMenu()
      item.onClick(e)
    }
  }

  translateMenuItem = (item, i) => {
    if (item.divider) return <Divider key={i}/>

    const {menuItems, leftIcon, primaryText, children, checked, insetChildren, ...itemProps} = item
    const label = isNil(primaryText) ? children : primaryText
    const icon = leftIcon || (isNil(checked) && !insetChildren
      ? null
      : <Icon name={iconNames.tick} style={checked ? null : {visibility: 'hidden'}}/>)

    if (menuItems) {
      return (
        <SubMenuItem key={i} {...itemProps} icon={icon} label={label}>
          {menuItems.map(this.translateMenuItem)}
        </SubMenuItem>
      )
    }

    return (
      <MenuItem key={i} {...itemProps} onClick={e => this.selectMenuItem(e, item)}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <span>{label}</span>
      </MenuItem>
    )
  }

  render() {
    const {menuItems, anchorOrigin, targetOrigin, ...buttonProps} = this.props
    const {open, anchor} = this.state

    const passThruProps = omit(buttonProps, ['isMenu', 'rangeAction'])

    const button = <Button key="b" {...passThruProps} onClick={this.showMenu}/>

    const menu = (
      <Menu
        key="p"
        classes={{paper: getClass('container')}}
        open={open}
        anchorEl={anchor}
        getContentAnchorEl={null}
        anchorOrigin={anchorOrigin}
        transformOrigin={targetOrigin}
        onClose={this.hideMenu}
        onClick={(e) => e.stopPropagation()}
        disableRestoreFocus={true}>
        {menuItems.map(this.translateMenuItem)}
      </Menu>
    )

    return [button, menu]
  }
}

MenuButton.propTypes = {
  menuItems: propTypes.array.isRequired,
  anchorOrigin: propTypes.object,
  targetOrigin: propTypes.object,
  onShowMenu: propTypes.func,
  ...Button.propTypes,
}

MenuButton.defaultProps = {
  anchorOrigin: {horizontal: 'left', vertical: 'bottom'},
  targetOrigin: {horizontal: 'left', vertical: 'top'},
}

export default MenuButton
